import { SvgIcon } from '@mui/material';
import React from 'react';

interface UnfinishedRoutesIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const UnfinishedRoutesIcon = ({ color = `#FFB215`, style = {}, ...props }: UnfinishedRoutesIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 13 12" style={{ fill: `none`, width: `13px`, height: `12px`, ...style }}>
      <g>
        <path
          d="M2.05615 7.5506C2.05615 7.5506 2.57304 7.03372 4.12371 7.03372C5.67437 7.03372 6.70815 8.06749 8.25881 8.06749C9.80948 8.06749 10.3264 7.5506 10.3264 7.5506V1.34794C10.3264 1.34794 9.80948 1.86483 8.25881 1.86483C6.70815 1.86483 5.67437 0.831055 4.12371 0.831055C2.57304 0.831055 2.05615 1.34794 2.05615 1.34794V7.5506Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2.05615 11.169V7.55078" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        <rect x="2.24463" y="1.03271" width="2.0358" height="2.0358" fill={color} />
        <rect x="4.28052" y="3.06836" width="2.0358" height="2.0358" fill={color} />
        <rect x="2.24463" y="5.10449" width="2.0358" height="2.0358" fill={color} />
        <path d="M6.31641 1.24072L8.35221 1.89488V3.06836H6.31641V1.24072Z" fill={color} />
        <rect x="8.35205" y="3.06836" width="2.0358" height="2.0358" fill={color} />
        <rect x="6.31641" y="5.10449" width="2.0358" height="2.0358" fill={color} />
        <path d="M4.28052 6.96387L6.31632 7.14017L6.31632 7.76223L4.28052 7.12354V6.96387Z" fill={color} />
        <path d="M8.3521 7.14014H10.3879V7.65575L8.35205 8.08155L8.3521 7.14014Z" fill={color} />
      </g>
    </SvgIcon>
  );
};
